module.exports = __webpack_public_path__ + "static/aus-7b3dbab128abbb409f8123949afac8cb.png";